import MethodCard from "components/payments/methods/MethodCard";
import { usePaymentContext } from "lib/contexts/PaymentProvider";
import { PaymentMode, PaymentModeType } from "lib/types/payments";
import { paymentMethodsConfig } from "lib/utils/payments";
import React from "react";
import { UPICollect } from "./upi/CollectAndIntent";
import ShopifyGiftCard from "./ShopifyGiftCard";
import CustomPayment from "./CustomPayment";
import GiftCard from "./GiftCard";
import { isS2SVerifiedForUpiIntentTile } from "lib/utils/helpers";
import { getUpiIntentModeConfig } from "lib/utils/payments";
import { useMerchantContext } from "lib/contexts/MerchantProvider";
import { useIsSubscribeMode } from "lib/hooks/useIsSubscribeMode";

interface MethodsContainerProps {
  renderMethods: PaymentMode[];
}

const HIDDEN_MODES: PaymentModeType[] = ["UPI_COLLECT"];
const HIDDEN_MODES_FOR_SPLIT_COD: PaymentModeType[] = ["SIMPL_PL", "SNPM", "SIMPL", "VELOCITY"];

const renderMethodComponent = (method: PaymentMode, showUpiIntentTile?: boolean) => {
  if (method.name === "UPI_INTENT" && showUpiIntentTile) return <UPICollect modeData={method} />;
  if (method.name === "SHOPIFY_GC" && method.isAvailable) return <ShopifyGiftCard />;
  if (method.name === "CUSTOM_PAYMENT" && method.isAvailable) return <CustomPayment />;
  if (method.name === "GC" && method.isAvailable) return <GiftCard />;
  return <MethodCard modeData={method} />;
};

const MethodsContainer: React.FC<MethodsContainerProps> = ({ renderMethods }) => {
  const {
    state: { openPaymentMethodDialog },
  } = usePaymentContext();
  const {
    state: { checkoutMetadata },
  } = useMerchantContext();
  const isSubscribeMode = useIsSubscribeMode();

  if (!renderMethods.length) return null;

  const upiIntentTile = renderMethods.find((item: PaymentMode) => item.name === "UPI_INTENT");

  const shouldShowUpiIntentTile = isS2SVerifiedForUpiIntentTile(
    getUpiIntentModeConfig(checkoutMetadata, isSubscribeMode),
    upiIntentTile,
  );

  const filteredMethods = renderMethods
    .filter(
      (method) =>
        method.name in paymentMethodsConfig &&
        !HIDDEN_MODES.includes(method.name) &&
        (method.name !== "UPI_INTENT" || shouldShowUpiIntentTile) &&
        (!(openPaymentMethodDialog === "SPLIT_COD") || !HIDDEN_MODES_FOR_SPLIT_COD.includes(method.name)),
    )
    .sort((a, b) => {
      if (a.name === "UPI_INTENT") return -1;
      if (b.name === "UPI_INTENT") return 1;
      return 0;
    });

  return (
    <>
      {filteredMethods.map((method, index) => (
        <div
          className={`overflow-hidden ${method.name === "UPI_INTENT" ? "" : ""}`}
          key={`${method.name}-${index}`}
          id={`flo__payments__${method.name}`}>
          {renderMethodComponent(method, shouldShowUpiIntentTile)}
        </div>
      ))}
    </>
  );
};

export default MethodsContainer;
